import { createSlice } from "@reduxjs/toolkit";
import { getServerDate } from "root/utils/date";

export const getDataForServerFromAnalyticsPricesParams = params => {
  const result = {};

  for (const key in params) {
    const value = params[key];
    if (value === "" || value == null || (Array.isArray(value) && value.length === 0)) continue;

    if (key === "subjects") {
      result["subject_id"] = value.map(item => item.id).join(",");
    } else if (key === "products") {
      result["product_id"] = value.map(item => item.id).join(",");
    } else if (key === "articles_date_range") {
      if (value?.[0]) result["create_date__gte"] = getServerDate(value[0]);
      if (value?.[1]) result["create_date__lte"] = getServerDate(value[1]);
    } else {
      result[key] = value;
    }
  }

  return result;
};

export const sppParams = {
  subjects: [],
  products: [],
  price_with_discount__gte: "",
  price_with_discount__lte: "",
  discount__gte: "",
  discount__lte: "",
  articles_date_range: [null, null],
  create_date__gte: "",
  create_date__lte: "",
};

const initialState = {
  params: {
    ...sppParams,
  },
  appliedParams: {},
  refreshTick: 0,
};

const sppSlice = createSlice({
  name: "sppV2",
  initialState,
  reducers: {
    setParamByName(state, { payload: { value, name } }) {
      state.params[name] = value;
    },
    setParams(state, { payload: savedParams }) {
      state.params = savedParams;
    },
    resetParams(state) {
      state.params = sppParams;
    },
    applyParams(state) {
      state.appliedParams = { ...state.params };
    },
    refresh(state) {
      state.refreshTick += 1;
    },
  },
});

export default sppSlice.reducer;
export const { setParamByName, setParams, resetParams, applyParams, refresh } = sppSlice.actions;
